import { useTypedQuery } from "hooks";
import { TyreGroupQueryKeys } from "modules/AppointmentDetails/components/VehicleTyres/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

const selectBrands = (brands: string[]) => brands.sort((a, b) => a.localeCompare(b)).map(b => ({ key: b, value: b.toLocaleLowerCase(), text: b }));

export const usePermanentTyreBrandOptions = (dealerLocation?: DealerLocation) => {
  const isTyreTeamEnabled = dealerLocation?.is_tyre_team_enabled === true;
  const queryKey = isTyreTeamEnabled ? TyreGroupQueryKeys.tyreTeamBrands(dealerLocation.id) : TyreGroupQueryKeys.brands;

  return useTypedQuery({
    queryKey,
    queryFn: async ({ endpoint, baseUrl, params }) => {
      if (isTyreTeamEnabled) return (await ApiInstance.post(endpoint, params, baseUrl)).data?.brands ?? [];
      return (await ApiInstance.get(endpoint, baseUrl)).data?.brands ?? [];
    },
    enabled: dealerLocation !== undefined,
    select: selectBrands
  });
};
